import React from 'react';
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import {API_CONFIG} from "../../config/api_config";
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';
import {Link} from "react-router-dom";
import "./c74_sitemap.scss";
// @ts-ignore
import isExternal from 'is-url-external';


interface MenuData {
    title: string;
    relative: string;
    below: MenuData[];
}


class C74Sitemap extends TemplateComponent {

    constructor(props: TemplateComponentProps) {
        super(props);

        const menuId = this.props.language === "en" ? API_CONFIG.ENGLISH_MENU_ID : API_CONFIG.ITALIAN_MENU_ID;
        this.dataUrl = `${API_CONFIG.BASE_URL}/menu/${this.props.language}/${menuId}?max_depth=6`;
    }

    renderTreeItem(menuItem: MenuData, index: number): React.ReactElement {
        return (
            <TreeItem nodeId={"sitemap-item-" + menuItem.title + index} key={"sitemap-item-" + menuItem.title + index}
                label={
                    isExternal(menuItem.relative) ?
                        <a className="sitemap-link" href={menuItem.relative}>{menuItem.title}</a>
                        :
                        <Link className="sitemap-link" to={menuItem.relative}>{menuItem.title}</Link>
                    } >
                {menuItem.below && !!menuItem.below.length &&
                    menuItem.below.map((child, childIndex) => this.renderTreeItem(child, childIndex))}
            </TreeItem>
        );
    }

    componentRender(data: any): React.ReactElement {

        return (
            <div className="c74-sitemap auto-margins">
                <TreeView
                    defaultExpanded={
                        // we expand the first two levels by default
                        data.map((item: MenuData, index: number) => [
                            "sitemap-item-" + item.title + index,
                            ...(item.below ? item.below.map((child, childIndex) => "sitemap-item-" + child.title + childIndex) : [])
                        ]).flat()
                    }
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<ChevronRightIcon />} >
                    {data.map((item: MenuData, index: number) => this.renderTreeItem(item, index))}
                </TreeView>
            </div>
        );
    }

}

export default C74Sitemap;